import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Warning, CheckCircle, Bell } from "@phosphor-icons/react";
import { toast } from "sonner";

const SEVERITY_COLOR = { High: "#EF4444", Medium: "#F97316", Low: "#64748B" };

export default function AlertsIncidents() {
  const [alerts, setAlerts] = useState([]);
  const [tab, setTab] = useState("All");

  const load = async () => { const { data } = await api.get("/alerts"); setAlerts(data); };
  useEffect(()=>{ load(); const t = setInterval(load, 15000); return ()=>clearInterval(t); }, []);

  const filtered = alerts.filter(a => tab==="All" || (tab==="Resolved" ? a.resolved : a.severity===tab && !a.resolved));

  const resolve = (id) => { setAlerts(p=>p.map(a=>a.id===id?{...a, resolved:true}:a)); toast.success("Alert resolved"); };

  const counts = {
    All: alerts.length,
    High: alerts.filter(a=>!a.resolved && a.severity==="High").length,
    Medium: alerts.filter(a=>!a.resolved && a.severity==="Medium").length,
    Low: alerts.filter(a=>!a.resolved && a.severity==="Low").length,
    Resolved: alerts.filter(a=>a.resolved).length,
  };

  return (
    <div className="p-4 lg:p-6 space-y-5 lg:space-y-6">
      <div>
        <div className="label-cap text-slate-500">Command Center</div>
        <h1 className="font-display text-2xl lg:text-3xl font-bold leading-tight">Alerts & Incidents</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {Object.entries(counts).map(([k,v])=>(
          <button key={k} onClick={()=>setTab(k)} className={`ktcl-card p-4 text-left transition-all ${tab===k?"border-[#1E3A8A] ring-1 ring-[#1E3A8A]":""}`}>
            <div className="label-cap text-slate-500">{k}</div>
            <div className="font-display text-2xl font-bold mt-2"
                 style={{color: k==="High"?"#EF4444":k==="Medium"?"#F97316":k==="Resolved"?"#22C55E":"#1E3A8A"}}>{v}</div>
          </button>
        ))}
      </div>
      <div className="ktcl-card overflow-x-auto scroll-thin">
        <table className="w-full text-sm min-w-[760px]">
          <thead className="bg-slate-50"><tr className="text-left text-xs text-slate-500">
            {"Time,Severity,Type,Fleet ID,Message,Status,Action".split(",").map(h=><th key={h} className="px-3 py-2 font-medium">{h}</th>)}
          </tr></thead>
          <tbody>
            {filtered.map(a=>(
              <tr key={a.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-3 py-2 text-xs font-mono">{new Date(a.timestamp).toLocaleString()}</td>
                <td className="px-3 py-2">
                  <span className="text-xs px-2 py-0.5 rounded text-white font-semibold" style={{background:SEVERITY_COLOR[a.severity]}}>{a.severity}</span>
                </td>
                <td className="px-3 py-2 font-medium">{a.type}</td>
                <td className="px-3 py-2 font-mono text-[#1E3A8A] font-bold">{a.fleet_id}</td>
                <td className="px-3 py-2 text-xs text-slate-600">{a.message}</td>
                <td className="px-3 py-2">
                  {a.resolved
                    ? <span className="text-xs px-2 py-0.5 bg-green-50 text-green-700 rounded flex items-center gap-1 w-fit"><CheckCircle size={12}/>Resolved</span>
                    : <span className="text-xs px-2 py-0.5 bg-red-50 text-red-700 rounded">Open</span>}
                </td>
                <td className="px-3 py-2 text-right">
                  {!a.resolved && <button onClick={()=>resolve(a.id)} className="text-xs px-2 py-1 border border-slate-200 rounded hover:bg-slate-100">Resolve</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
